import PropTypes from 'prop-types'

const propTypes = {
  onSelect: PropTypes.func.isRequired,
}

export default propTypes
